function Hero() {
  return (
    <header>
      <h2 className="hero-title">Subsidiary Portfolio</h2>
    </header>
  );
}

export default Hero;
